import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-images.tsx
/**
* icon.24.images
*
* Keywords: photo, image, picture, gallery, square-frame, mountain-landscape, sun, photography
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE2LjUgOEExLjUgMS41IDAgMCAxIDE4IDkuNXY3YTEuNSAxLjUgMCAwIDEtMS4zNDcgMS40OTJMMTYuNSAxOGgtN2wtLjE1My0uMDA4YTEuNSAxLjUgMCAwIDEtMS4zNC0xLjMzOUw4IDE2LjV2LTdBMS41IDEuNSAwIDAgMSA5LjUgOHptLTcgMWEuNS41IDAgMCAwLS41LjV2N2EuNS41IDAgMCAwIC41LjVoN2EuNS41IDAgMCAwIC41LS41di03YS41LjUgMCAwIDAtLjUtLjV6bTYtM2EuNS41IDAgMCAxIDAgMUg4YTEgMSAwIDAgMC0xIDF2Ny41YS41LjUgMCAwIDEtMSAwVjhhMiAyIDAgMCAxIDItMnptLTQuMjc1IDYuMDgyYS41LjUgMCAwIDEgLjYyOS4wNjRsMyAzYS41LjUgMCAxIDEtLjcwNy43MDdMMTEuNSAxMy4yMDhsLS42NDYuNjQ2YS41LjUgMCAxIDEtLjcwNy0uNzA3bDEtMXpNMTQuNSAxMC41YTEgMSAwIDEgMSAwIDIgMSAxIDAgMCAxIDAtMiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-2923
*/
const Icon24Images = memo(function Icon24Images(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M16.5 8A1.5 1.5 0 0 1 18 9.5v7a1.5 1.5 0 0 1-1.347 1.492L16.5 18h-7l-.153-.008a1.5 1.5 0 0 1-1.34-1.339L8 16.5v-7A1.5 1.5 0 0 1 9.5 8zm-7 1a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5zm6-3a.5.5 0 0 1 0 1H8a1 1 0 0 0-1 1v7.5a.5.5 0 0 1-1 0V8a2 2 0 0 1 2-2zm-4.275 6.082a.5.5 0 0 1 .629.064l3 3a.5.5 0 1 1-.707.707L11.5 13.208l-.646.646a.5.5 0 1 1-.707-.707l1-1zM14.5 10.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
		})
	});
});
//#endregion
export { Icon24Images };

//# sourceMappingURL=icon-24-images.js.map